var React = require('react');

function ArrowDiagonal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m53 8h-23.899c-1.104 0-2 .896-2 2s.896 2 2 2h21.071l-40.586 40.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l40.586-40.586v21.071c0 1.104.896 2 2 2s2-.896 2-2v-23.899c0-2.206-1.794-4-4-4z"}));
}

ArrowDiagonal.defaultProps = {"id":"Layer","enableBackground":"new 0 0 64 64","height":"512","viewBox":"0 0 64 64","width":"512"};

module.exports = ArrowDiagonal;

ArrowDiagonal.default = ArrowDiagonal;
